// extracted by mini-css-extract-plugin
export var active = "commentsSectionDesktop-module--active--a8c60";
export var button = "commentsSectionDesktop-module--button--71652";
export var comment = "commentsSectionDesktop-module--comment--1b947";
export var image = "commentsSectionDesktop-module--image--ad043";
export var name = "commentsSectionDesktop-module--name--3b1ff";
export var pagination = "commentsSectionDesktop-module--pagination--345e7";
export var quote = "commentsSectionDesktop-module--quote--8e540";
export var slider = "commentsSectionDesktop-module--slider--46ba9";
export var sliderPicture = "commentsSectionDesktop-module--sliderPicture--91d3e";
export var subQuote = "commentsSectionDesktop-module--subQuote--d387e";
export var wrapper = "commentsSectionDesktop-module--wrapper--2af27";